import React from "react";
import { faqs } from "../data/content";
import { Disclosure } from "./ui/Disclosure";
import { SectionHeading } from "./ui/SectionHeading";
export function FaqSection() {
  return <section id="faq" className="scroll-mt-16 bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-87" data-mp="1bkseho10z5ad">
      <SectionHeading title="Domande frequenti" data-id="element-88" data-mp="1gjlrlfcegua0" />
      <div className="mx-auto mt-8 max-w-3xl border-t border-line" data-id="element-89" data-mp="1gkepdqtds9g0">
        {faqs.map(f => <Disclosure key={f.question} title={f.question} variant="chevron" data-id="element-90" data-mp="24ahf409tp3bg">
            {f.answer}
          </Disclosure>)}
      </div>
    </section>;
}